<div class="main">
  <nf-app-container
    appTitle="Helios"
    appIconUrl="/helios/assets/HeliosLogo.svg"
  >
    <div class="content">
      <h1>Inactive Page</h1>
      <p>
        It looks like your tab has been inactive for a while. Automatic reload
        is about to occur.
      </p>
    </div>
  </nf-app-container>
</div>
